const prodConfig = {
  AUTH_API_BASE_URL: 'https://gateway.sunrun.com/portal-auth',
  PAYMENT_API_BASE_URL: 'https://gateway.sunrun.com/payment-service',
  ROLLBAR_TOKEN: 'e912239341d44a6bb6da41b3f518df8e',
  CLIENT_HOST: 'my.sunrun.com',
  CONTENT_SERVICE_URL: 'https://fvvvpq32yg.execute-api.us-west-2.amazonaws.com/prod',
  CONTENT_SERVICE_ACCESS_TOKEN: '9tRm6hTcKE9xA56382nO9nZqMUVCBCESwh_pV2ippOE',
  ROLLBAR_ENV: 'prd',
  BUSINESS_ENV: 'prd',
  USER_API_BASE_URL: 'https://gateway.sunrun.com/portal-user',
  QUESTION_ANSWER_API_URL: 'https://gateway.sunrun.com/question-answer',
  STATUS_TRACKER_API_URL: 'https://gateway.sunrun.com/status-tracker',
  REFERRAL_API_BASE_URL: 'https://gateway.sunrun.com/portal-referral',
  WEATHER_API_BASE_URL: 'https://gateway.sunrun.com/portal-weather',
  SUPPORT_API_BASE_URL: 'https://gateway.sunrun.com/portal-support',
  SERVICE_TRANSFER_API_BASE_URL: 'https://gateway.sunrun.com/service-transfer',
  CASES_API_BASE_URL: 'https://gateway.sunrun.com/portal-cases',
  PERFORMANCE_BASE_URL: 'https://gateway.sunrun.com/performance-api',
  NOTIFICATION_BASE_URL: 'https://gateway.sunrun.com/portal-notifications',
  GRID_SERVICE_BASE_URL: 'https://gateway.sunrun.com/portal-grid-services',
  SPLAT_CAP_BASE_URL: 'https://gateway.sunrun.com/splat-cap',
  SPLAT_BASE_URL: 'https://go.sunrun.com',
  MIXPANEL_KEY: '44192616deb0d07c752f7f42414aca94',
  ENABLE_GRID_CHARTS: false,
  INCONTACT_CHAT_LINK: 'https://home-c16.incontact.com/incontact/chatclient/chatclient.aspx?poc=786a1de5-8882-4943-9c9c-a151488248b0&bu=4595152',
  GOOGLE_MAP_API_KEY: 'AIzaSyAErcXuZ-i5rrWeP9ZAggzPNU8Ei2yVaOw',
  GOOGLE_ANALYTICS_TRACKING_ID: 'UA-4657551-26',
  GOOGLE_TAG_MANAGER_ID: 'GTM-TR5GPN7',
  OPTIMIZE_ID: 'GTM-NPLB9F5',
  ENABLE_SHOW_CCMETHOD_FROM_PREPAID: false,
  ENABLE_CHART_DATA_TYPES: true,
  FORCE_ENABLE_CHART_OPTIONS: false,
  ENABLE_BATTERY_OPTION: false,
  ENABLE_IN_CONTACT_CHAT: true,
  ENABLE_AUTOPAY_CC: false,
  ENABLE_CASE_TABLE: true,
  ENABLE_SYSTEM_STATUS: true,
  ENABLE_DASHBOARD_NOTIFICATION_CARDS: true,
  PORTAL_SUPPORT_API_KEY: 'i1OUVtJtHp5AdlmblVCMF4IBtKjsLnMw3ruWAY96',
  ENABLE_SDGE_PAGE: true,
  ENABLE_SDGE_TESTING_MESSAGE: false,
  ENABLE_BATTERY_RETRO_SPLAT_LINK: false,
  ENABLE_VIEW_DOC_BUTTON_STATUS_TRACKER: true,
  FLAGSMITH_ENV_ID: 'noF7ZmcLCLxn7D5csG4Xyh',
};

export default prodConfig;
